import styled from "styled-components";

const constants = require("../constants");

export default styled.div`
  display: flex;
  align-items: start;
  color: ${props => props.color || "#4a4e5a"};
  min-height: ${props => props.height || "20px"};
  line-height: ${props => props.height || "20px"};
  margin: ${props => props.margin || "0 0 8px 0"};
  flex-wrap: ${props => props.wrap || "wrap"};
  & > *:first-child {
    width: 120px;

    @media only screen and (max-width: ${constants.breakpoints.lg}px) {
      width: 100px;
    }
  }

  & > *:last-child {
    max-width: ${props => (props.removeMaxWidth ? "none" : "220px")};

    @media only screen and (max-width: ${constants.breakpoints.lg}px) {
      max-width: 100%;
    }
  }

  ${props => props.css}
`;
